// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-profile {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.profile-item {
  width: 100%;
  min-height: 140px;
  background-color: white;
  border-radius: 3px;
}
.profile-item .profile-item-line {
  height: 3px;
  border-radius: 3px 3px 0px 0px;
  background-color: rgb(255, 92, 180);
}
.profile-item .profile-item-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 20px 15px 10px 15px;
}
.profile-item .profile-item-content .profile-item-content-avatar {
  width: 90px;
  height: 90px;
  padding: 2px;
  border-radius: 100%;
  box-shadow: 0px 0px 2px 3px rgba(128, 128, 128, 0.404);
}
.profile-item .profile-item-content .profile-item-content-name {
  font-size: 22px;
  font-weight: 500;
  text-align: center;
}
.profile-item .profile-item-content .profile-item-content-network {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  min-height: 20px;
}
.profile-item .profile-item-content .profile-item-content-network img {
  width: 35px;
}

@media only screen and (max-width: 800px) {
  .list-profile .profile-item {
    width: 100% !important;
  }
}
@media only screen and (min-width: 800px) and (max-width: 1200px) {
  .list-profile .profile-item {
    width: calc(50% - 10px) !important;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1700px) {
  .list-profile .profile-item {
    width: calc(33% - 20px) !important;
  }
}
@media only screen and (min-width: 1700px) {
  .list-profile .profile-item {
    width: calc(33% - 10px) !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/search-profile/ListProfile.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AACJ;;AAEA;EACI,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AAAI;EACI,WAAA;EACA,8BAAA;EACA,mCAAA;AAER;AAAI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;AAER;AADQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,sDAAA;AAGZ;AADQ;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAGZ;AADQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,gBAAA;AAGZ;AAFY;EACI,WAAA;AAIhB;;AAEA;EAEQ;IACI,sBAAA;EAAV;AACF;AAGA;EAEQ;IACI,kCAAA;EAFV;AACF;AAKA;EAEQ;IACI,kCAAA;EAJV;AACF;AAOA;EAEQ;IACI,kCAAA;EANV;AACF","sourcesContent":[".list-profile {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 20px;\n}\n\n.profile-item {\n    width: 100%;\n    min-height: 140px;\n    background-color: white;\n    border-radius: 3px;\n    .profile-item-line {\n        height: 3px;\n        border-radius: 3px 3px 0px 0px;\n        background-color: rgb(255 92 180);\n    }\n    .profile-item-content {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 15px;\n        padding: 20px 15px 10px 15px;\n        .profile-item-content-avatar {\n            width: 90px;\n            height: 90px;\n            padding: 2px;\n            border-radius: 100%;\n            box-shadow: 0px 0px 2px 3px rgba(128, 128, 128, 0.404);\n        }\n        .profile-item-content-name {\n            font-size: 22px;\n            font-weight: 500;\n            text-align: center;\n        }\n        .profile-item-content-network {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            gap: 20px;\n            min-height: 20px;\n            img {\n                width: 35px;\n            }\n        }\n    }\n}\n\n@media only screen and (max-width: 800px) {\n    .list-profile {\n        .profile-item {\n            width: 100% !important;\n        }\n    }\n}\n@media only screen and (min-width: 800px) and (max-width: 1200px) {\n    .list-profile {\n        .profile-item {\n            width: calc(50% - 10px) !important;\n        }\n    }\n}\n@media only screen and (min-width: 1200px) and (max-width: 1700px) {\n    .list-profile {\n        .profile-item {\n            width: calc(33% - 20px) !important;\n        }\n    }\n}\n@media only screen and (min-width: 1700px)  {\n    .list-profile {\n        .profile-item {\n            width: calc(33% - 10px) !important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
